// src/Components/CKEditorFull.tsx
import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./CKEditor.css";
// import {

// 	Autosave,
// 	Essentials,
// 	Paragraph,
// 	Alignment,
// 	AutoImage,
// 	Autoformat,
// 	AutoLink,
// 	Bold,
// 	CloudServices,
// 	FontBackgroundColor,
// 	FontColor,
// 	FontFamily,
// 	FontSize,
// 	GeneralHtmlSupport,
// 	Heading,
// 	ImageEditing,
// 	ImageInsertViaUrl,
// 	ImageStyle,
// 	ImageTextAlternative,
// 	ImageToolbar,
// 	ImageUpload,
// 	ImageUtils,
// 	ImageInline,
// 	Indent,
// 	IndentBlock,
// 	Italic,
// 	Link,
// 	List,
// 	PlainTableOutput,
// 	Strikethrough,
// 	Style,
// 	Table,
// 	TableCaption,
// 	TableToolbar,
// 	TextTransformation,
// 	Underline,
// 	HorizontalLine,
// 	TodoList,
// 	SourceEditing
// } from 'ckeditor5';

// Word count plugin kräver ClassicEditor build med WordCount-plugin
// ClassicEditor från npm har redan många plugins inbyggda

interface Props {
  value: string;
  onChange: (value: string) => void;
}
const CKEditorFull: React.FC<Props> = ({ value, onChange }) => {

  return (
    <div className="ckeditor-shell">
      <CKEditor
        editor={ClassicEditor as any}
        data={value}
        onChange={(_, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
        config={{
          toolbar: [
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "link",
            "blockQuote",
            "|",
            "bulletedList",
            "numberedList",
            "insertTable",
            "mediaEmbed",
            "code",
            "codeBlock",
            "removeFormat",
            "fullscreen",
          ],
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
          mediaEmbed: {
            previewsInData: true,
          },
          // Word count visas i status bar automatiskt i ClassicEditor
        }}
      />
    </div>
  );
};

export default CKEditorFull;
